/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

// This code is auto-generated by Plasmic; please do not edit!
// Plasmic Project: dpdRoEHB1RdkpQGeaRP58K

import { createUseStyleTokens } from "@plasmicapp/react-web";

import { _useGlobalVariants } from "./plasmic"; // plasmic-import: dpdRoEHB1RdkpQGeaRP58K/projectModule

const data = {
  base: `${"plasmic_tokens_dpdRoEHB1RdkpQGeaRP58K"} ${"plasmic_tokens_5ZtnypMovRHeeP3YTdPCYL"} ${"plasmic_tokens_ohDidvG9XsCeFumugENU3J"}`,
  varianted: []
};

export const _useStyleTokens = createUseStyleTokens(data, _useGlobalVariants);
